// ESM
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'
import LazyLoad from "vanilla-lazyload"
import ReadMore from './components/read-more'
import intlTelInput from 'intl-tel-input'
import SimpleLightbox from "simplelightbox"
import addProductToCart from './components/alpine/add-product-to-cart'
import commandeAdresseAutocomplete from './components/alpine/commande-adresse-autocomplete'
import animatedInputLabel from './components/alpine/animated-input-label'
// import navInputsLivewire  from './components/alpine/nav-inputs-livewire'
import 'input-clear-icon/input-clear-icon.regular.css'
import 'input-clear-icon/input-clear-icon.js'

// Cookies banner configuration
window.BloomCookies = {
    bandeau_text: "Nous utilisons des cookies pour assurer le bon fonctionnement du site, personnaliser le contenu et les publicités, proposer des fonctionnalités relatives aux réseaux sociaux et analyser le trafic. Nous partageons parfois des informations liées à votre navigation avec nos partenaires analytiques, publicitaires et réseaux sociaux. Pour en savoir plus sur les cookies, les données utilisées et les traitements réalisés, ainsi que ceux de nos partenaires, veuillez consulter notre <a href='https://moto.honda.fr/motorcycles/useful-links/cookie-policy.html' target='_blank'>politique de confidentialité</a>.",
    modale_intro: "Lorsque vous consultez un site Web, des données peuvent être stockées dans votre navigateur ou récupérées à partir de celui-ci, généralement sous la forme de cookies. Ces informations peuvent porter sur vous, sur vos préférences ou sur votre appareil et sont principalement utilisées pour s'assurer que le site Web fonctionne correctement. Les informations ne permettent généralement pas de vous identifier directement, mais peuvent vous permettre de bénéficier d'une expérience Web personnalisée. Parce que nous respectons votre droit à la vie privée, nous vous donnons la possibilité de ne pas autoriser certains types de cookies. Cliquez sur les différentes catégories pour obtenir plus de détails sur chacune d'entre elles, et modifier les paramètres par défaut. Toutefois, si vous bloquez certains types de cookies, votre expérience de navigation et les services que nous sommes en mesure de vous offrir peuvent être impactés. Pour en savoir plus sur les cookies, les données que nous utilisons, les traitements que nous réalisons et les partenaires avec qui nous travaillons, vous pouvez consulter notre <a href='https://moto.honda.fr/motorcycles/useful-links/cookie-policy.html' target='_blank'>politique de confidentialité</a>.",
    order: [0, 3, 2, 1]
};

// UMD
const Sticky = require('sticky-js')
const CookieBanner = require('@bloom/cookies/dist/cookies.umd.js')

Swiper.use([Navigation, Pagination])

/// Init global app namespace
window.HondaEshop = window.HondaEshop || {}

/**
 * First we will load all of this project's JavaScript dependencies.
 */
require('./bootstrap');

/**
 * Application code
 */

Alpine.data('addProductToCart', addProductToCart)
Alpine.data('commandeAdresseAutocomplete', commandeAdresseAutocomplete)
Alpine.plugin(animatedInputLabel)
// Alpine.plugin(navInputsLivewire)
Alpine.start()

// Sticky header
const headerSticky = new Sticky('#site-header', {
    wrap: true,
    wrapWith: '<span id="site-header-sticky"></span>'
});

// Main offcanvas menu
const menuOpenedClass = 'is-menu-opened'
const mainMenu = document.getElementById('offcanvas')
mainMenu.addEventListener('show.bs.offcanvas', () => document.body.classList.add(menuOpenedClass))
mainMenu.addEventListener('hide.bs.offcanvas', () => document.body.classList.remove(menuOpenedClass))

// Lazy load
const lazyNative = new LazyLoad({
    use_native: true
})
const lazyBackground = new LazyLoad({})

Livewire.hook('element.updated', (el, component) => {
    lazyNative.update()
    lazyBackground.update()

    setTimeout(function(){
        lazyNative.update()
        lazyBackground.update()
    }, 100);
})

const initTooltips = () => {
    // Tooltips
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    })
}

// Read more
ReadMore.init()

document.querySelectorAll('.btn-deploy').forEach(function(btn){
    const container = btn.parentNode.parentNode;
    btn.addEventListener('click', function(e){
        e.preventDefault()
        container.style.maxHeight = container.querySelector('.row').offsetHeight + 'px'
        container.classList.toggle('collapsed')
    })
})

const handleProductAttributInputs = () => {
    document.querySelectorAll('.nav-attributes-inputs').forEach((item) => {

        item.querySelectorAll('.btn-input').forEach((btn) => {
            btn.addEventListener('click', () => {
                const checked = item.querySelector('input:checked')

                if(checked) checked.checked = false
            })

        })
    })
}
// Product view
let existingLightbox = false
let existingProductimageSlider = false
const initProductPage = () => {

    const siteHeader = document.getElementById('site-header');

    const priceStickyLarge = new Sticky('#product-bloc-price-large', {
        wrap: true,
        wrapWith: '<span id="product-bloc-price-large-sticky" class="product-bloc-price-sticky"></span>',
        marginTop: siteHeader.offsetHeight - 40,
        stickyClass: 'is-price-sticky'
    });
    const priceStickySmall = new Sticky('#product-bloc-price-small', {
        wrap: true,
        wrapWith: '<span id="product-bloc-price-small-sticky" class="product-bloc-price-sticky"></span>',
        marginTop: siteHeader.offsetHeight - 40,
        stickyClass: 'is-price-sticky'
    });

    handleProductAttributInputs()

    const productSlider = document.querySelector('#product-image-slider');

    if(productSlider) {
        if(existingProductimageSlider) {
            existingProductimageSlider.destroy()
            existingProductimageSlider = false
        }

        existingProductimageSlider = new Swiper(productSlider, {
            modules: [Navigation, Pagination, Autoplay],
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: false,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            autoplay: {
                delay: 2500,
                pauseOnMouseEnter: true
            },
        })

        if(existingLightbox) {
            existingLightbox.destroy()
            existingLightbox = false
        }
        existingLightbox = new SimpleLightbox('#product-image-slider .swiper-slide img', {
            sourceAttr: 'data-src-full',
            showCounter: false
        })
    }

    initTooltips()
}
initProductPage();
window.addEventListener('refresh-product-page', initProductPage)

// Product list slider
const initSliders = () => {
    document.querySelectorAll('.swiper:not(.swiper-initialized):not(#product-image-slider)').forEach(function(slider){
        const swiper = new Swiper(slider, {
            modules: [Navigation, Pagination, Autoplay],
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: false,
            centerInsufficientSlides: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            autoplay: {
                delay: 2500*3
            },
            breakpoints: {
                575: {
                    slidesPerView: 2,
                    spaceBetween: 15
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 15
                },
                992: {
                    slidesPerView: 4,
                    pagination: false,
                    navigation: (slider.querySelectorAll('.swiper-slide').length > 4)
                }
            }
        })
    })
}
initSliders()
window.addEventListener('refresh-sliders', initSliders)

// Checkout
const initCheckoutForm = () => {
    initTooltips()

    const input = document.querySelector("#phone");
    input && intlTelInput(input, {
        onlyCountries: ['fr'],
        initialCountry: 'fr',
        autoPlaceholder: 'off',
        dropdownContainer: document.querySelector('#phone-countries'),
        utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/8.4.6/js/utils.js"
    });
}
window.addEventListener('refresh-checkout-form', initCheckoutForm)

const scrollTopCheckout = () => {
    lazyNative.update()
    lazyBackground.update()

    const page = document.querySelector('body')
    page && page.scrollIntoView()
}
window.addEventListener('scroll-top-checkout', scrollTopCheckout)

const headerVisibilityCheckout = (event) => {
    const headerStickyEl = document.getElementById('site-header-sticky')
    if(!headerStickyEl) return;

    if(!event.detail || event.detail.show == false) {
        headerStickyEl.classList.remove('show')
    } else {
        headerStickyEl.classList.add('show')
    }
    headerSticky.update()
}
window.addEventListener('show-header-checkout', headerVisibilityCheckout)

// Display product added alert on mobile
let productAddedNotification = false
const templateProductAdded = document.getElementById('template-product-added-alert')
const productAdded = () => {
    if(!productAddedNotification) {
        productAddedNotification = true
        templateProductAdded.classList.add('visible')
        setTimeout(() => {
            productAddedNotification = false
            templateProductAdded.classList.remove('visible')
        }, 1.5e3)
    }
}
Livewire.on('productAdded', productAdded)

// Popinfo
const setCookie = (name, value, days) => {
    var d = new Date;
    d.setTime(d.getTime() + 24*60*60*1000*days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}
const popinfoAlert = document.getElementById('alert-popinfo')
if(popinfoAlert) {
    const cookieName = popinfoAlert.dataset.cookie || 'popinfo_closed';
    const cookieDays = popinfoAlert.dataset.cookieDays || 30;
    popinfoAlert.addEventListener('closed.bs.alert', function () {
        setCookie(cookieName, '1', cookieDays)
    })
}

// Search page display clear input on load

const triggerFocus = (element) => {
    const eventType = "onfocusin" in element ? "focusin" : "focus"
    const bubbles = "onfocusin" in element
    let event

    if ("createEvent" in document) {
        event = document.createEvent("Event")
        event.initEvent(eventType, bubbles, true)
    }
    else if ("Event" in window) {
        event = new Event(eventType, { bubbles: bubbles, cancelable: true })
    }

    element.focus()
    element.dispatchEvent(event)
}

if(document.body.classList.contains('search')) {
    let currentSearchField = document.querySelector('.search-query')
    if(!currentSearchField.getClientRects().length) {
        currentSearchField = document.querySelector('.header-mob .search-query')
    }

    if(currentSearchField.value.length) {
        if(document.readyState == 'complete') {
            setTimeout(() => triggerFocus(currentSearchField), 300)
        } else {
            window.addEventListener('load', () => {
                setTimeout(() => triggerFocus(currentSearchField), 300)
            })
        }
    }
}

let initializeOffcanvasFiltersInitialized = false;
const initializeOffcanvasFilters = function() {
    const productListElement = document.getElementById('product-list');
    const filterCollapseElement = document.getElementById('offcanvas-filters');
    if(filterCollapseElement) {
        initializeOffcanvasFiltersInitialized = true;

        const filterCollapse = new bootstrap.Collapse(filterCollapseElement, {
            toggle: false
        });

        let filtersVisible = false;
        const toggleFilters = (show) => {
            if(!show) {
                filtersVisible = false;
                filterCollapse.hide();
                productListElement.style.paddingTop = '0px';
            } else {
                filtersVisible = true;
                filterCollapse.show();
                productListElement.style.paddingTop = filterCollapseElement.offsetHeight + 'px';
            }
        }

        document.body.addEventListener('click', (e) => {
            if(e.target.dataset.offcanvasFiltersToggle || e.target.dataset.offcanvasFiltersToggle == '') {
                toggleFilters(!filtersVisible); // toggle
            }
        })

        window.addEventListener('openfilters', function(){
            toggleFilters(true); // show
        })
    }
}
if(document.readyState == 'complete') {
    initializeOffcanvasFilters()
} else {
    document.addEventListener("DOMContentLoaded", () => initializeOffcanvasFilters())
}

// document.addEventListener("DOMContentLoaded", () => {
//     Livewire.hook('element.initialized', (el, component) => {
//         console.log(component.fingerprint.name);
//         if(component.fingerprint.name = "filter" && !initializeOffcanvasFiltersInitialized) {
//             initializeOffcanvasFilters()
//         }
//     })
// })